import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { ShiftParameters } from "../models/ShiftParameters";

export const getShiftParameters = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[MES].[GetShiftParameters]", []);
	return resp;
};

export const upsertShiftParameters = async ({
	PatternStart,
	ShiftCodes,
	Crews,
	CrewRotation,
	Comments,
}: ShiftParameters) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "AssetId", value: null });
	parameters.push({ name: "PatternStart", value: PatternStart });
	parameters.push({ name: "ShiftCodes", value: ShiftCodes });
	parameters.push({ name: "Crews", value: Crews });
	parameters.push({ name: "CrewRotation", value: CrewRotation });
	parameters.push({ name: "Comments", value: Comments });

	const resp = await apiService.callV2(
		"[MES].[UpsertShiftParameters]",
		parameters,
	);
	return resp;
};

export const DeleteShiftParameters = async (PatternStart: Date) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "AssetId", value: null });
	parameters.push({ name: "PatternStart", value: PatternStart });

	const resp = await apiService.callV2(
		"[MES].[DeleteShiftParameters]",
		parameters,
	);
	return resp;
};
